import type { ReactNode } from "react";
import { cn } from "../lib/cn";

/**
 * A workspace page's header (docs/design/meridian.md, card 113): an optional breadcrumb above, the title with what
 * marks it (a status badge), a sentence of what the page is for, and the page's actions at the end, at most one of
 * them primary. `id` names the page's section through `aria-labelledby`.
 */
export function PageHeader({
  id,
  title,
  description,
  marks,
  actions,
  breadcrumb,
  className,
}: {
  id?: string | undefined;
  title: ReactNode;
  description?: ReactNode;
  marks?: ReactNode;
  actions?: ReactNode;
  breadcrumb?: ReactNode;
  className?: string | undefined;
}) {
  return (
    <div className={cn("flex flex-col gap-3", className)}>
      {breadcrumb}
      <div className="flex flex-wrap items-start justify-between gap-x-6 gap-y-3">
        <div className="flex min-w-0 flex-col gap-1">
          <div className="flex flex-wrap items-center gap-3">
            <h2 id={id} className="text-title font-semibold text-ink">
              {title}
            </h2>
            {marks}
          </div>
          {description !== undefined && (
            <p className="max-w-[68ch] text-body text-ink-muted">{description}</p>
          )}
        </div>
        {actions !== undefined && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
      </div>
    </div>
  );
}
